import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {LaboratoireReference} from '../../../class/api/LaboratoireReference';
import {Personne} from '../../../class/api/Personne';
import {Adresse} from '../../../class/api/Adresse';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {api} from '../../../api/api-dictionnary';
import {HydraService} from '../../../core/services/hydra.service';
import {ToolsService} from '../../services/tools/tools.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GeocoderComponent } from '../geocoder/geocoder.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-nouveau-laboratoire-reference',
    templateUrl: './modal-nouveau-laboratoire-reference.component.html',
    styleUrls: ['./modal-nouveau-laboratoire-reference.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatSelect, MatOption, GeocoderComponent, MatCheckbox, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ModalNouveauLaboratoireReferenceComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalNouveauLaboratoireReferenceComponent>>(MatDialogRef);
    private _formBuilder = inject(UntypedFormBuilder);
    private hydraService = inject(HydraService);
    private toolService = inject(ToolsService);


    constructor() {}

    public labo = new LaboratoireReference();

    firstFormGroup: UntypedFormGroup = new UntypedFormGroup({});

    public nouvelleAdresse: Adresse = new Adresse();
    ngOnInit() {
        this.firstFormGroup = this._formBuilder.group({
            label: [''],
            civilite: [''],
            directeur_nom: [''],
            directeur_prenom: [''],
            sigle: [''],
            CLCC: [false],
            APHP: [false],
        });
    }

    public compareByValue(itemOne, itemTwo) {
        return itemOne == itemTwo;
    }

    public compareByLetter(itemOne, itemTwo) {
        return itemOne == itemTwo;
    }

    public addLabo() {
        const data = { ...this.firstFormGroup.getRawValue() };
        this.labo.etat = 1;
        this.labo.CLCC = data['CLCC'];
        this.labo.APHP = data['APHP'];
        this.labo.label = data['label'];
        this.labo.directeur = new Personne({});
        this.labo.directeur.civilite = data['civilite'];
        this.labo.directeur.nom = data['directeur_nom'];
        this.labo.directeur.prenom = data['directeur_prenom'];
        this.labo.adresse = this.nouvelleAdresse;
        this.labo.sigle = data['sigle'];
        delete this.labo.id;

        const url = api.laboratoiresReferences;

        this.hydraService.save(url, this.labo).subscribe(
            res => {
                this.toolService.notificationSuccess(
                    'L\'utilisateur a bien été ajoutée'
                );

                this.dialogRef.close();
            },
            err => {
            }
        );
    }

    get label() {
        return this.firstFormGroup.get('label');
    }
    get civilite() {
        return this.firstFormGroup.get('civilite');
    }
    get directeur_nom() {
        return this.firstFormGroup.get('directeur_nom');
    }
    get directeur_prenom() {
        return this.firstFormGroup.get('directeur_prenom');
    }
    get adresse() {
        return this.firstFormGroup.get('adresse');
    }
    get CLCC() {
        return this.firstFormGroup.get('CLCC');
    }
    get APHP() {
        return this.firstFormGroup.get('APHP');
    }
    get sigle() {
        return this.firstFormGroup.get('sigle');
    }
}
